import { closeActions, FooterStart, onFinish } from './common';
import React from 'react';

export const TIPS_CUSTOM_FIELD_GROUPS = {
    title: 'Custom Field Groups',
    subTitle: '',
    releaseDate: new Date(2025, 2, 18),
    requiredRole: [],
    closeActions,
    onFinish,
    slides: [
        {
            upperTitle: 'New Feature!',
            footerStart: (
                <FooterStart url="https://hubplanner.com/custom-field-groups-use-your-custom-fields-at-scale/" />
            ),
            title: 'Custom Field Groups',
            subTitle: `Custom Field Groups help manage custom fields at scale. Organize by department, project type, or role. Apply to resources and projects for a streamlined workflow.`,
            imageUrl: 'https://hubplanner-static.s3.eu-west-1.amazonaws.com/img/cfg_new_extension.jpg',
        },
    ],
};
